import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Modal, Dialog, Button } from '@oliasoft-open-source/react-ui-library';
import { removeTask, tasksDeselected } from 'store/entities/activity-model/activity-model';
import { selectActivityModelLoaders } from 'store/entities/activity-model/selectors';
import translations from 'src/internationalisation/translation-map.json';
import { withErrorBoundary } from '@oliasoft-open-source/react-ui-library';

const TaskDeleteModal = ({
  setModalVisible,
  removeTask,
  task,
  setActiveForm,
  tasksDeselected,
  projectId,
  isDeleting,
}) => {
  const { t } = useTranslation();
  const onClose = () => setModalVisible(false);
  const onDelete = () => {
    removeTask(task, { projectId });
    setModalVisible(isDeleting);
    if (!task.isBranch) {
      setActiveForm(null);
      tasksDeselected();
    }
  };

  return (
    <Modal visible centered fullScreen>
      <Dialog
        dialog={{
          heading: t(
            task.isBranch ? translations.activityModel_deleteBranch : translations.activityModel_deleteActivity,
          ),
          content: (
            <>
              {t(
                task.isBranch
                  ? translations.activityModel_areYouSureYouWantToDeleteThisBranch
                  : translations.activityModel_areYouSureYouWantToDeleteThisActivity,
              )}
            </>
          ),
          footer: (
            <>
              <Button
                testId="delete-modal-button-delete"
                label={t(translations.delete)}
                colored
                loading={isDeleting}
                disabled={isDeleting}
                onClick={onDelete}
              />
              <Button label={t(translations.cancel)} onClick={onClose} />
            </>
          ),
          onClose,
        }}
      />
    </Modal>
  );
};

const mapStateToProps = (state) => {
  const { isDeleting } = selectActivityModelLoaders(state);
  return {
    isDeleting,
  };
};

const mapDispatchToProps = { removeTask, tasksDeselected };

const Container = withErrorBoundary(connect(mapStateToProps, mapDispatchToProps)(TaskDeleteModal), { isModal: true });

export { Container as TaskDeleteModal };
